export const defaultCommonStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: 80,
  height: 80,
  borderRadius: "0%",
  borderStyle: "none",
  borderWidth: "0",
  borderColor: "#ffffff00",
  transform: 0,
};
